import React, { useState } from "react";

const SecondaryButtonLevelSection = ({
  disabled,
  isClick,
  prefix,
  suffix,
  onClick,
  children,
  style,
}) => {
  const [defaultState, setDefaultState] = useState(disabled ? false : true);
  const [hoveredState, setHoveredState] = useState(false);
  const [clickedState, setClickedState] = useState(isClick ? isClick : false);
  // const audio = new Audio("/sounds/click.mp3");
  var buttonStyle = {
    height: "2.5rem",
    fontSize: "1rem",
    borderRadius: "1.25rem",
    border: "1px solid #0A2A66",
    // color: disabled ? "#8C9DC1" : "#FAFBFC",
    boxShadow: "none",
  };
  var prefixStyle = {
    position: "absolute",
    width: "1rem",
    height: "1rem",
    zIndex: "100",
    backgroundImage: `url(${prefix})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    top: "0.75rem",
    left: "1.375rem",
    backgroundColor: disabled
      ? "#8C9DC1"
      : clickedState
      ? "#FAFBFC"
      : "#0A2A66",
  };
  var suffixStyle = {
    position: "absolute",
    width: "1rem",
    height: "1rem",
    zIndex: "100",
    backgroundImage: `url(${suffix})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    top: "0.75rem",
    right: "1.375rem",
    backgroundColor: disabled
      ? "#8C9DC1"
      : clickedState
      ? "#FAFBFC"
      : "#0A2A66",
  };

  if (hoveredState) {
    buttonStyle = {
      ...buttonStyle,
      filter: "drop-shadow(0rem 0.375rem 0.75rem rgba(10, 42, 102, 0.25))",
    };
  }

  const handleMouseEnter = () => {
    if (!clickedState && !disabled) {
      setDefaultState(false);
      setHoveredState(true);
    }
  };
  const handleMouseLeave = () => {
    if (!clickedState && !disabled) {
      setDefaultState(true);
      setHoveredState(false);
    }
  };
  const handleClick = () => {
    if (!disabled) {
      // audio.play();
      setClickedState(!clickedState);
      setHoveredState(false);
      setDefaultState(clickedState);
      if (onClick) {
        onClick();
      }
    }
  };
  const handleBlur = () => {
    setClickedState(false);
    setDefaultState(true);
  };
  return (
    <div
      className="main is-relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onBlur={handleBlur}
      style={{ maxWidth: "10rem" }}
    >
      {prefix && <div style={prefixStyle}></div>}
      <button
        className={`${
          defaultState
            ? "is-secondary-button-default-color"
            : hoveredState
            ? "is-secondary-button-default-color"
            : clickedState
            ? "is-secondary-button-clicked-color"
            : disabled
            ? "is-button-disabled-color"
            : ""
        }  button  main-color has-text-weight-bold is-uppercase has-text-centered ${
          disabled
            ? "has-text-button-disabled-text-color"
            : clickedState
            ? "has-text-secondary-button-default-color"
            : "has-text-secondary-button-clicked-color"
        }`}
        style={{ ...buttonStyle, ...style }}
        onClick={handleClick}
        type="button"
      >
        {children}
      </button>
      {suffix && <div style={suffixStyle}></div>}
    </div>
  );
};

export default SecondaryButtonLevelSection;
